import styled from 'styled-components';

import Icon from '~/src/common/components/Icon';
import { hideScrollbar } from '~/src/common/themes/main/shared-styles';
import { media } from '~/src/styles-constants';

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const GoBackButton = styled.button`
  display: none;

  ${media.M`
    padding: 0;
    margin-left: 8px;
    border: none;
    background: ${({ theme }) => theme.palette.common.TRANSPARENT};
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;

    color: ${({ theme }) => theme.palette.common.PRIMARY};

    &:hover {
      color: ${({ theme }) => theme.palette.common.PRIMARY_HOVER};
    }

      display: flex;
      align-items: center;

      span:last-child {
        margin-left: 8px;
      }
  `}
`;

export const BreadcrumbsContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-x: scroll;
  ${hideScrollbar}

  & span {
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;

    &::first-letter {
      text-transform: uppercase;
    }
  }

  & > span:last-child {
    color: ${({ theme }) => theme.palette.common.DISABLED};
  }

  ${Icon} {
    position: relative;
    font-size: 16px;
  }
`;
